import { Component, inject, OnChanges, WritableSignal, signal, input } from '@angular/core';
import { RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { firstValueFrom } from 'rxjs';
import { AssignmentService, AssignmentType, PositionDto } from '../../shared/generated/backend';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-assignment-positions',
  imports: [SharedModule, RichTextEditorModule, DxDataGridModule],
  standalone: true,
  templateUrl: './assignment-positions.component.html',
  styleUrl: './assignment-positions.component.scss',
})
export class AssignmentPositionsComponent implements OnChanges {
  readonly assignmentId = input.required<number>();

  readonly type = input.required<AssignmentType>();

  positions: WritableSignal<PositionDto[]> = signal([]);
  readonly isLoading: WritableSignal<boolean> = signal(false);

  private assignmentService = inject(AssignmentService);

  async ngOnChanges() {
    this.isLoading.set(true);
    const dto = await firstValueFrom(this.assignmentService.getPositions(this.assignmentId(), this.type()));
    this.positions.set(dto);
    this.isLoading.set(false);
  }
}
